import view from "../../Enums";
import { makeStyle } from "../../utils";
import { columnCenter, rowCenter, h6, subTitle1, caption, bold } from "../../resources/styles";

const styles = {};


styles['container'] = makeStyle({ backgroundColor: 'lightgrey' }, { padding: '16px 24px' }, { padding: 12 }, { ...columnCenter, padding: 12 });


styles['line_1'] = makeStyle({}, rowCenter, view.DESKTOP, columnCenter);

styles['logo_props'] = makeStyle({ color: 'var(--theme-color)' }, { width: '110px', height: '40px', viewBox: '0 0 55 20' }, {});

styles['logo'] = makeStyle({}, { padding: 16 }, { padding: 12 }, { padding: 6 });

styles['worlds_fastest'] = makeStyle({}, { ...h6, padding: 16 }, { ...subTitle1, padding: 12 }, { ...subTitle1, textAlign: 'center', padding: 6 });


styles['line_2'] = makeStyle({ ...rowCenter, padding: 16, }, {}, { padding: 12 }, { padding: 6 });

styles['link_divider'] = makeStyle({ width: 1, height: 10, backgroundColor: 'grey', margin: '0 12px' });


styles['line_3'] = makeStyle({}, { ...rowCenter, justifyContent: 'space-between' }, view.DESKTOP, columnCenter);

styles['social_links'] = makeStyle({}, { padding: 16 }, { padding: 12 }, { padding: 6 });

styles['social_link'] = makeStyle({ marginRight: 12 });


styles['company_name'] = makeStyle([caption, bold], { padding: 16 }, { padding: 12 }, { textAlign: 'center', padding: 6 });


export default styles;